import { useEffect } from "react";
import LegalShell from "@/components/masar/LegalShell";
import LegalBody from "@/components/masar/LegalBody";
import { useLanguage } from "@/i18n/LanguageContext";
import { termsBlocks } from "@/i18n/legalContent";

export default function Terms() {
  const { lang, t } = useLanguage();
  useEffect(() => {
    document.title = `MASAR — ${t("legal.termsTitle")}`;
  }, [t]);
  return (
    <LegalShell title={t("legal.termsTitle")} updated={t("legal.updated")}>
      <LegalBody blocks={termsBlocks[lang] || termsBlocks.en} />
    </LegalShell>
  );
}
